export const orderStatuses = {
    NOT_ASSIGNED: 'Не назначена',
    AWAIT_ACCEPTANCE: 'Ожидает принятия',
    DONE: 'Готова',
    CANCEL: 'Отмена клиентом',
    REJECT: 'Отказ',
    MODERN: 'Модерн',
    ACCEPTED: 'Принял',
    IN_WAY: 'В пути',
    WORKING: 'В работе',
    FINISHING: 'Оформляется',
};

export const orderTypes = {
    IS_FIRST_TIME: 'Впервые',
    IS_NOT_FIRST_TIME: 'Повторно',
    WARRANTY: 'Гарантия',
}

export const monthNames = [
    'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
];

const HAS_USERS_INTERACTION_ACCESS = 'HAS_USERS_INTERACTION_ACCESS';
const ALL_USERS = 'ALL_USERS';
const ALL_CITIES = 'ALL_CITIES';
const ALL_PROFILES = 'ALL_PROFILES';
const CAN_EDIT_LOWER_USER = 'CAN_EDIT_LOWER_USER';
const PERSONAL_DATA_ACCESS = 'PERSONAL_DATA_ACCESS';
const CAN_CREATE_USER = 'CAN_CREATE_USER';
const CAN_EDIT_USER = 'CAN_EDIT_USER';
const CAN_SEE_ORDER_HISTORY = 'CAN_SEE_ORDER_HISTORY';
const CAN_SEE_USER_HISTORY = 'CAN_SEE_ORDER_HISTORY';

const HAS_ORDERS_ACCESS = 'HAS_ORDERS_ACCESS';
const HAS_OFFICE_ACCESS = 'HAS_OFFICE_ACCESS';
const ALL_USER_ORDERS = 'ALL_USER_ORDERS';
const ALL_PROFILE_ORDERS = 'ALL_PROFILE_ORDERS';
const ALL_CITY_ORDERS = 'ALL_CITY_ORDERS';

const CAN_CREATE_ORDER = 'CAN_CREATE_ORDER';
const CAN_EDIT_ORDER = 'CAN_EDIT_ORDER';
const CAN_DELETE_ORDER = 'CAN_DELETE_ORDER';
const CAN_ASSIGN_ORDER = 'CAN_ASSIGN_ORDER';
const CAN_RESET_ORDER = 'CAN_RESET_ORDER';

const CAN_HAND_OVER = 'CAN_HAND_OVER';
const HAS_REVENUES_ACCESS = 'HAS_REVENUES_ACCESS';
const HAS_EXPENSES_ACCESS = 'HAS_EXPENSES_ACCESS';
const CAN_CREATE_EXPENSE = 'CAN_CREATE_EXPENSE';
const ALL_CATEGORIES_ACCESS = 'ALL_CATEGORIES_ACCESS';

const CAN_SEE_CLIENT_NUMBERS = 'CAN_SEE_CLIENT_NUMBERS';

const CAN_RECEIVE_CALLS = 'CAN_RECEIVE_CALLS';

const CAN_REVOKE_ORDER = 'CAN_REVOKE_ORDER';

const CAN_CANCEL_ORDER = 'CAN_CANCEL_ORDER';
const CAN_MODERN_ORDER = 'CAN_MODERN_ORDER';
const CAN_DONE_ORDER = 'CAN_DONE_ORDER'; 

const CAN_EDIT_IS_PROFILE = 'CAN_EDIT_IS_PROFILE';
const CAN_EDIT_WORKER = 'CAN_EDIT_WORKER';
const CAN_EDIT_COMPLETE_DATA = 'CAN_EDIT_COMPLETE_DATA';

const CAN_USE_APP = 'CAN_USE_APP';
const CAN_WORK_ON_ORDERS = 'CAN_WORK_ON_ORDERS';
const HAS_ADVERT_ACCESS = 'HAS_ADVERT_ACCESS';
const HAS_PROMOTERS_INTERACT_ACCESS = 'HAS_PROMOTERS_INTERACT_ACCESS';

export const perms = {
    HAS_USERS_INTERACTION_ACCESS,
    CAN_CREATE_USER,
    CAN_EDIT_USER,
    CAN_EDIT_LOWER_USER,
    HAS_ORDERS_ACCESS,
    HAS_OFFICE_ACCESS,
    ALL_USER_ORDERS,
    ALL_PROFILE_ORDERS,
    ALL_CITY_ORDERS,
    ALL_USERS,
    ALL_CITIES,
    ALL_PROFILES,
    PERSONAL_DATA_ACCESS,
    CAN_SEE_ORDER_HISTORY,
    CAN_SEE_USER_HISTORY,
    
    CAN_RESET_ORDER,
    CAN_SEE_CLIENT_NUMBERS,
    CAN_RECEIVE_CALLS,

    CAN_CREATE_ORDER,
    CAN_EDIT_ORDER,
    CAN_DELETE_ORDER,
    CAN_ASSIGN_ORDER,

    CAN_CANCEL_ORDER,
    CAN_MODERN_ORDER,
    CAN_DONE_ORDER,

    CAN_HAND_OVER,
    HAS_REVENUES_ACCESS,
    HAS_EXPENSES_ACCESS,
    CAN_CREATE_EXPENSE,
    ALL_CATEGORIES_ACCESS,

    CAN_EDIT_IS_PROFILE,
    CAN_EDIT_WORKER,
    CAN_EDIT_COMPLETE_DATA,

    CAN_USE_APP,
    CAN_WORK_ON_ORDERS,
    CAN_REVOKE_ORDER,

    HAS_ADVERT_ACCESS,
    HAS_PROMOTERS_INTERACT_ACCESS,
}